<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        style="width: 150px"
        class="filter-item"
        placeholder="门类名称/代码"
        v-model="listQuery.classification"
      ></el-input>
      <el-input
        style="width: 150px"
        class="filter-item"
        placeholder="一级学科名称/代码"
        v-model="listQuery.first_level"
      ></el-input>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="list"
      v-loading.body="listLoading"
      element-loading-text="加载中 ..."
      border
      highlight-current-row
    >
      <el-table-column
        label="门类"
        width="300"
        align="center"
        prop="classification"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="一级学科"
        width="300"
        align="center"
        prop="first_level_display"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="热门院校数量"
        width="300"
        align="center"
        prop="hot_school"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
        v-if="checkPermission(['nav.change_masterdegreeinfo'])"
      >
        <template slot-scope="{ row: { uuid, first_level } }">
          <el-button
            type="text"
            size="mini"
            v-permission="['nav.change_masterdegreeinfo']"
            @click="$refs.hotSchoolRef.show(uuid, first_level)"
            >热门院校</el-button
          >

          <el-button
            type="text"
            size="mini"
            v-permission="['nav.change_masterdegreeinfo']"
            @click="$refs.videoRef.show(uuid)"
            >一级学科解读</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>

    <dialog-hot-school ref="hotSchoolRef"></dialog-hot-school>
    <dialog-video ref="videoRef"></dialog-video>
  </div>
</template>

<script>
import { getSchoolMajors } from '@/api/pick_school'

import checkPermission from '@/utils/permission'

import DialogHotSchool from '@/views/pick-school/components/index/dialog-hot-school'
import DialogVideo from '@/views/pick-school/components/index/dialog-video'

export default {
  name: 'PickSchool',
  data() {
    return {
      list: null,
      count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        size: 10,
        classification: '',
        first_level: '',
      },
    }
  },
  components: {
    DialogHotSchool,
    DialogVideo,
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    checkPermission,
    // 获取数据
    fetchData() {
      this.listLoading = true
      getSchoolMajors(this.listQuery).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    // 设为默认
    handleDefault(row, value) {},
    // 设为隐藏
    handleShow(row, value) {},
    // 删除
    handleDel(uuid) {},
  },
}
</script>
